var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SRPJwtBearerAuth_instances, _SRPJwtBearerAuth_config, _SRPJwtBearerAuth_options, _SRPJwtBearerAuth_customProvider, _SRPJwtBearerAuth_getAuthSession, _SRPJwtBearerAuth_login, _SRPJwtBearerAuth_createSrpLoginRawMessage;
import { ValidationError } from "../errors.mjs";
import { getMetaMaskProviderEIP6963 } from "../utils/eip-6963-metamask-provider.mjs";
import { MESSAGE_SIGNING_SNAP, connectSnap, isSnapConnected } from "../utils/messaging-signing-snap-requests.mjs";
import { validateLoginResponse } from "../utils/validate-login-response.mjs";
import { authenticate, authorizeOIDC, getNonce } from "./services.mjs";
const getDefaultEIP6963Provider = async () => {
    const provider = await getMetaMaskProviderEIP6963();
    if (!provider) {
        throw new ValidationError('No MetaMask wallet connected');
    }
    return provider;
};
const getDefaultEIP6963SigningOptions = (customProvider) => ({
    getIdentifier: async () => {
        const provider = customProvider ?? (await getDefaultEIP6963Provider());
        return await MESSAGE_SIGNING_SNAP.getPublicKey(provider);
    },
    signMessage: async (message) => {
        const provider = customProvider ?? (await getDefaultEIP6963Provider());
        if (!message.startsWith('metamask:')) {
            throw new ValidationError('message must start with "metamask:"');
        }
        const formattedMessage = message;
        return await MESSAGE_SIGNING_SNAP.signMessage(provider, formattedMessage);
    },
});
export class SRPJwtBearerAuth {
    constructor(config, options) {
        _SRPJwtBearerAuth_instances.add(this);
        _SRPJwtBearerAuth_config.set(this, void 0);
        _SRPJwtBearerAuth_options.set(this, void 0);
        _SRPJwtBearerAuth_customProvider.set(this, void 0);
        __classPrivateFieldSet(this, _SRPJwtBearerAuth_config, config, "f");
        __classPrivateFieldSet(this, _SRPJwtBearerAuth_customProvider, options.customProvider, "f");
        __classPrivateFieldSet(this, _SRPJwtBearerAuth_options, {
            storage: options.storage,
            signing: options.signing ??
                getDefaultEIP6963SigningOptions(__classPrivateFieldGet(this, _SRPJwtBearerAuth_customProvider, "f")),
        }, "f");
    }
    setCustomProvider(provider) {
        __classPrivateFieldSet(this, _SRPJwtBearerAuth_customProvider, provider, "f");
        __classPrivateFieldGet(this, _SRPJwtBearerAuth_options, "f").signing = getDefaultEIP6963SigningOptions(provider);
    }
    async getAccessToken() {
        const session = await __classPrivateFieldGet(this, _SRPJwtBearerAuth_instances, "m", _SRPJwtBearerAuth_getAuthSession).call(this);
        if (session) {
            return session.token.accessToken;
        }
        const loginResponse = await __classPrivateFieldGet(this, _SRPJwtBearerAuth_instances, "m", _SRPJwtBearerAuth_login).call(this);
        return loginResponse.token.accessToken;
    }
    async getUserProfile() {
        const session = await __classPrivateFieldGet(this, _SRPJwtBearerAuth_instances, "m", _SRPJwtBearerAuth_getAuthSession).call(this);
        if (session) {
            return session.profile;
        }
        const loginResponse = await __classPrivateFieldGet(this, _SRPJwtBearerAuth_instances, "m", _SRPJwtBearerAuth_login).call(this);
        return loginResponse.profile;
    }
    async getIdentifier() {
        return await __classPrivateFieldGet(this, _SRPJwtBearerAuth_options, "f").signing.getIdentifier();
    }
    async signMessage(message) {
        return await __classPrivateFieldGet(this, _SRPJwtBearerAuth_options, "f").signing.signMessage(message);
    }
    async isSnapConnected() {
        const provider = __classPrivateFieldGet(this, _SRPJwtBearerAuth_customProvider, "f") ?? (await getDefaultEIP6963Provider());
        if (!provider) {
            return false;
        }
        const isConnected = await isSnapConnected(provider);
        return isConnected;
    }
    async connectSnap() {
        const provider = __classPrivateFieldGet(this, _SRPJwtBearerAuth_customProvider, "f") ?? (await getDefaultEIP6963Provider());
        const res = await connectSnap(provider);
        return res;
    }
}
_SRPJwtBearerAuth_config = new WeakMap(), _SRPJwtBearerAuth_options = new WeakMap(), _SRPJwtBearerAuth_customProvider = new WeakMap(), _SRPJwtBearerAuth_instances = new WeakSet(), _SRPJwtBearerAuth_getAuthSession = 
// convert expiresIn from seconds to milliseconds and use 90% of expiresIn
async function _SRPJwtBearerAuth_getAuthSession() {
    const auth = await __classPrivateFieldGet(this, _SRPJwtBearerAuth_options, "f").storage.getLoginResponse();
    if (!validateLoginResponse(auth)) {
        return null;
    }
    const currentTime = Date.now();
    const sessionAge = currentTime - auth.token.obtainedAt;
    const refreshThreshold = auth.token.expiresIn * 1000 * 0.9;
    if (sessionAge < refreshThreshold) {
        return auth;
    }
    return null;
}, _SRPJwtBearerAuth_login = async function _SRPJwtBearerAuth_login() {
    // Nonce
    const address = await this.getIdentifier();
    const nonceRes = await getNonce(address, __classPrivateFieldGet(this, _SRPJwtBearerAuth_config, "f").env);
    const publicKey = await __classPrivateFieldGet(this, _SRPJwtBearerAuth_options, "f").signing.getIdentifier();
    const rawMessage = __classPrivateFieldGet(this, _SRPJwtBearerAuth_instances, "m", _SRPJwtBearerAuth_createSrpLoginRawMessage).call(this, nonceRes.nonce, publicKey);
    const signature = await this.signMessage(rawMessage);
    // Authenticate
    const authResponse = await authenticate(rawMessage, signature, __classPrivateFieldGet(this, _SRPJwtBearerAuth_config, "f").type, __classPrivateFieldGet(this, _SRPJwtBearerAuth_config, "f").env);
    // Authorize
    const tokenResponse = await authorizeOIDC(authResponse.token, __classPrivateFieldGet(this, _SRPJwtBearerAuth_config, "f").env, __classPrivateFieldGet(this, _SRPJwtBearerAuth_config, "f").platform);
    // Save
    const result = {
        profile: authResponse.profile,
        token: tokenResponse,
    };
    await __classPrivateFieldGet(this, _SRPJwtBearerAuth_options, "f").storage.setLoginResponse(result);
    return result;
}, _SRPJwtBearerAuth_createSrpLoginRawMessage = function _SRPJwtBearerAuth_createSrpLoginRawMessage(nonce, publicKey) {
    return `metamask:${nonce}:${publicKey}`;
};
//# sourceMappingURL=flow-srp.mjs.map